import { OktaAuth } from '@okta/okta-auth-js';

import {
  CLIENT_ID,
  ISSUER,
  POST_LOGOUT_REDIRECT_URI,
  REDIRECT_URI,
} from '../../env';

const oktaAuth = new OktaAuth({
  clientId: CLIENT_ID,
  issuer: ISSUER,
  redirectUri: REDIRECT_URI,
  postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI,
  scopes: ['openid', 'offline_access'],
  responseMode: 'query',
  responseType: 'code',
  disableHttpsCheck: true,
  prompt: 'none',
  tokenManager: {
    storage: 'sessionStorage',
    expireEarlySeconds: 30,
    autoRenew: true,
  },
});

export default oktaAuth;
